import { Alert, Paragraph } from '@digdir/designsystemet-react';

import styled from '../../styled';

import { useSystemAlert } from './useSystemAlert';

const StyledAlert = styled(Alert)`
  margin: var(--ds-size-1) auto;
  max-width: var(--max-width);
  width: 100%;
  display: flex;
  gap: var(--ds-size-4);
  flex-direction: column;
`;

const TitleSpan = styled.span`
  font-weight: bold;
`;

export const SystemAlert = () => {
  const messages = useSystemAlert();

  if (messages.length === 0) {
    return null;
  }

  return (
    <StyledAlert data-color="warning">
      {messages.map((message, index) => (
        <div key={index}>
          <Paragraph>
            <TitleSpan>{message.title}</TitleSpan>
            {` - ${message.content}`}
          </Paragraph>
        </div>
      ))}
    </StyledAlert>
  );
};
